<template>
  <b-modal
    id="success_buy_package"
    ref="success_buy_package"
    hide-footer>
    <div class="success-modal">
      <img src="../../assets/img/success.png">
      <div>
        Chúc mừng
      </div>
      <div>
        Bạn đã mua gói tư vấn phong thuỷ theo ngày thành công. Cùng trải nghiệm thêm nhiều tiện ích nào!!!
      </div>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "SuccessBuyPackage"
    }
</script>

<style lang="scss" scoped>
  .success-modal {
    text-align: center;
    padding: 16px;

    img {
      display: table-cell;
      object-fit: cover;
      margin: auto auto 8px;
    }

    > div {
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      align-items: center;
      text-align: center;
      color: #017EDD;
      margin-top: 8px;

      &:last-child {
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #505565;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/SuccessBuyPackage.vue